import { createApiHandler } from './handler';

const barfheroImport = {
  apiClient: null,
  path: '/barfhero_import',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },

  async getNextUsers() {
    try {
      const response = await this.apiClient.get(`${this.path}/nextusers`);
      return response.data;
    } catch (error) {
      console.log('error', error);
      throw error;
    }
  },

};

export default barfheroImport;
